export const STATUS_REVIEW = 'REVIEW';
export const STATUS_COMPLETE = 'COMPLETE';
export const STATUS_DENY = 'DENY';

export const REQUEST_ACCESS_STATUS_VALUES = [STATUS_REVIEW, STATUS_COMPLETE, STATUS_DENY];
